module.exports = __webpack_public_path__ + "assets/img/aboutUS-module1-3.39a071fa.jpg";